// ============================================================================
// JAPANESE TRANSLATIONS - BIBLE VERSES
// ============================================================================
// ストロング番号付きの感動的な聖句集

export const bibleVerses = [
  {
    reference: "ピリピ人への手紙 4:13",
    text: "私を強くしてくださる方によって、私はどんなことでもできるのです",
    version: "新改訳",
    theme: "力",
    strongNumbers: {
      "できる": "G1411", // δύναμις (dynamis) = 力、能力
      "強くする": "G1743" // ἐνδυναμόω (endynamoo) = 強める
    },
    context: "パウロはキリストによってあらゆる状況に対処できることを語っている"
  },
  {
    reference: "詩篇 23:1",
    text: "主は私の羊飼い。私は乏しいことがありません",
    version: "新改訳",
    theme: "守り",
    strongNumbers: {
      "羊飼い": "H7462", // רָעָה (ra'ah) = 羊を飼う、世話をする
      "乏しい": "H2637" // חָסֵר (chaser) = 欠ける、必要とする
    },
    context: "ダビデが神の摂理への完全な信頼を表している"
  },
  {
    reference: "ヨハネの福音書 3:16",
    text: "神は、実に、そのひとり子をお与えになったほどに、世を愛された",
    version: "新改訳",
    theme: "愛",
    strongNumbers: {
      "愛された": "G25", // ἀγαπάω (agapao) = 無条件に愛する
      "与えた": "G1325" // δίδωμι (didomi) = 与える、授ける
    },
    context: "神の人類への愛について最も有名な聖句"
  },
  {
    reference: "ピリピ人への手紙 4:7",
    text: "そうすれば、人のすべての考えにまさる神の平安が、あなたがたの心と思いを守ってくれます",
    version: "新改訳",
    theme: "平安",
    strongNumbers: {
      "平安": "G1515", // εἰρήνη (eirene) = 平安、調和
      "守る": "G5432" // φρουρέω (phroureo) = 守る、保護する
    },
    context: "内なる平安を通じた神の守りの約束"
  },
  {
    reference: "詩篇 119:105",
    text: "あなたのみことばは、私の足のともしび、私の道の光です",
    version: "新改訳",
    theme: "導き",
    strongNumbers: {
      "ともしび": "H5216", // נִיר (niyr) = ともしび、光
      "光": "H216" // אוֹר (or) = 光、照明
    },
    context: "日常生活における導きとしての神のことば"
  },
  {
    reference: "箴言 3:5-6",
    text: "心を尽くして主に拠り頼め。自分の悟りにたよるな",
    version: "新改訳",
    theme: "信頼",
    strongNumbers: {
      "拠り頼め": "H982", // בָּטַח (batach) = 信頼する
      "心": "H3820" // לֵב (leb) = 心、思い、意志
    },
    context: "自分の能力ではなく神に信頼するよう招いている"
  },
  {
    reference: "マタイの福音書 5:14",
    text: "あなたがたは、世界の光です。山の上にある町は隠れる事ができません",
    version: "新改訳",
    theme: "証し",
    strongNumbers: {
      "光": "G5457", // φῶς (phos) = 光、霊的な照明
      "世界": "G2889" // κόσμος (kosmos) = 世界、宇宙
    },
    context: "イエスは弟子たちが世の証人となることを励ましている"
  }
];

export default bibleVerses;
